import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useCommunicationService } from 'src/app/services/communication';
import { MessageType } from 'src/app/utils/in-app-comunication/types';

type TimerProps = {
  className?: string;
  isPresenterView?: boolean;
  elapsedTime: number;
  reset: () => void;
};

const TimerWrapper = styled.div<{ $isPresenterView?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(3)}`};
  border: ${({ theme, $isPresenterView }) => ($isPresenterView ? 'none' : `2px solid ${theme.colors.green}`)};
  background: ${({ theme, $isPresenterView }) =>
    $isPresenterView ? 'transparent' : theme.colors.greenWithTransparency};
  border-radius: ${({ theme }) => theme.spacing(3)};
  color: ${({ theme }) => theme.colors.white};
  font-weight: 600;
  font-size: ${({ theme }) => theme.typography.jumbo};
  width: auto;
`;

const Digit = styled.span`
  display: inline-block;
  width: 0.97ch;
  text-align: center;
`;

const Separator = styled.div`
  margin: 0 ${({ theme }) => theme.spacing(1)};
`;

const Timer: React.FC<TimerProps> = ({ className, isPresenterView = false, elapsedTime, reset }) => {
  const comms = useCommunicationService();
  useEffect(() => {
    const unsubscribe = comms.onMessage((message) => {
      if (message.type === MessageType.SLIDESHOW_CHANGE) {
        reset();
      }
    });
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [comms, reset]);

  const safeElapsedTime = typeof elapsedTime === 'number' && !isNaN(elapsedTime) ? elapsedTime : 0;
  const minutes = String(Math.floor(safeElapsedTime / 60)).padStart(2, '0');
  const seconds = String(Math.floor(safeElapsedTime % 60)).padStart(2, '0');

  return (
    <TimerWrapper data-testid="timer-wrapper" className={className} $isPresenterView={isPresenterView}>
      <Digit>{minutes[0]}</Digit>
      <Digit>{minutes[1]}</Digit>
      <Separator>:</Separator>
      <Digit>{seconds[0]}</Digit>
      <Digit>{seconds[1]}</Digit>
    </TimerWrapper>
  );
};

export default Timer;
